import { CategoriesData, SubCategoriesData, TestData } from '../types';

export const transformCategory = (data: any): CategoriesData => {
  return {
    allTests: data.allTests,
    clinicalLaboratory: data.clinicalLaboratory,
    genetics: data.genetics,
    infectology: data.infectology,
    slug: data.slug,
    sortingNumber: data.sortingNumber,
    tests: data.tests,
    subCategories: data.subCategories,
    id: data.id,
    name: data.name
  };
};

export const transformSubCategory = (data: any): SubCategoriesData => {
  return {
    slug: '',
    tests: [],
    id: data.id,
    name: data.name
  };
};

export const transformTest = (data: any): TestData => {
  const convertToNumber = (value: any): number | undefined => {
    if (value === undefined || value === null) {
      return undefined;
    }
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed === "" || trimmed === "null" || trimmed === "undefined") {
        return undefined;
      }
      const num = Number(trimmed);
      return isNaN(num) ? undefined : num;
    }
    if (typeof value === "number") {
      return isNaN(value) ? undefined : value;
    }
    return undefined;
  };

  return {
    airportCovidTest: data.airportCovidTest,
    cardDescription: data.cardDescription,
    categoryId: data.categoryId,
    covidTestType: data.covidTestType,
    duration: data.duration,
    fullDescription: data.fullDescription,
    genicaCovidTest: data.genicaCovidTest,
    id: data.id,
    mobileLabCovidTest: data.mobileLabCovidTest,
    sortingNumber: data.sortingNumber,
    name: data.name,
    priceEur: convertToNumber(data.priceEur),
    priceRange: convertToNumber(data.priceRange),
    _draft: data._draft || false,
    sample: data.sample,
    slug: data.slug,
    subCategories: data.subCategories,
    subCategoryId: data.subCategoryId
  };
};
